module.exports = __webpack_public_path__ + "ebae409ba07738aa62614f91843ef8c3.png";